import { createContext, useContext, useState, useCallback } from 'react';

const CompareContext = createContext();

export const useCompare = () => {
  const context = useContext(CompareContext);
  if (!context) {
    throw new Error('useCompare must be used within CompareProvider');
  }
  return context;
};

export const CompareProvider = ({ children }) => {
  const [compareList, setCompareList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const MAX_COMPARE = 3;

  const addToCompare = useCallback((car) => {
    setCompareList(prev => {
      if (prev.length >= MAX_COMPARE) return prev;
      if (prev.find(c => c.id === car.id)) return prev;
      return [...prev, car];
    });
  }, []);

  const removeFromCompare = useCallback((carId) => {
    setCompareList(prev => prev.filter(c => c.id !== carId));
  }, []);

  const isInCompare = useCallback((carId) => {
    return compareList.some(c => c.id === carId);
  }, [compareList]);

  const clearCompare = useCallback(() => {
    setCompareList([]);
  }, []);

  const openModal = useCallback(() => {
    if (compareList.length >= 2) {
      setIsModalOpen(true);
    }
  }, [compareList.length]);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  return (
    <CompareContext.Provider value={{
      compareList,
      addToCompare,
      removeFromCompare,
      isInCompare,
      clearCompare,
      isModalOpen,
      openModal,
      closeModal,
      maxCompare: MAX_COMPARE
    }}>
      {children}
    </CompareContext.Provider>
  );
};
